export default __webpack_public_path__ + "static/Tapetsering2-cff3d3d584f85a1fa7ef7548c434fa87.jpg";